import { useForm } from '@mantine/form';
import { useTranslation } from 'react-i18next';

export const useCreateDirectoryForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      folderName: '',
    },
    validate: {
      folderName: value => {
        if (!value || value.length < 3) {
          return t('documents.form.invalidFolderName', 'Nom invalide');
        }

        const forbiddenChars = /[/\\:*?"<>|]/;
        if (forbiddenChars.test(value)) {
          return t(
            'documents.form.forbiddenChars',
            'Les caractères suivants sont interdits: / \\ : * ? " < > |'
          );
        }

        return null;
      },
    },
  });

  return { form };
};
